import React from "react";
import CustomTooltip from "common/tooltip";
import alertIcon from "svg/red-alert-icon.svg";

const ProductDisplay = ({ number, name, category }) => (
  <div className="d-flex">
    <div className="d-flex flex-column pe-2" style={{ borderRight: "1px solid #d1d1d1", width: 90 }}>
      <span style={{ fontSize: 12, color: "#454545c2" }}>Sales #</span>
      <span className={number ? "" : "highLightSales"}>
        {number ?? "NA"}
        {!number && (
          <CustomTooltip placement="top" trigger="hover" text="Sales Number is empty">
            <img className="alert_style" src={alertIcon} alt="" />
          </CustomTooltip>
        )}
      </span>
    </div>
    <div className="d-flex flex-column px-2" style={{ borderRight: "1px solid #d1d1d1" }}>
      <span style={{ fontSize: 12, color: "#454545c2" }}>Name</span>
      {name ?? "NA"}
    </div>
    <div className="d-flex flex-column px-2">
      <span style={{ fontSize: 12, color: "#454545c2" }}>Category</span>
      {category ?? "NA"}
    </div>
  </div>
);

export default ProductDisplay;
